import { IPromo } from '../../types/newbuilding/promos';

export const getPromoDate = (promo?: IPromo) => {
  if (!promo || (!promo.start && !promo.end) || promo.isBlackFriday) {
    return '';
  }

  return 'Действует ' + [promo.start, promo.end].filter(value => value).join(' ');
};
